import DefaultNavbar from "components/DefaultNavbar";
import DefaultFooter from "components/DefaultFooter";

import HeaderPrivacyPolicy from "../components/Mis/HeaderPrivacyPolicy";

export default function PrivacyPolicy(props) {
  return (
    <>


        <HeaderPrivacyPolicy

        />
        {/*<WorkingSection />*/}
        {/*<TeamSection />*/}
        {/*<ContactSection />*/}

      {/*<DefaultFooter />*/}
    </>
  );
}
